import type { ProductVersionFormat } from '../../model/model.ts'

export const esRcphProductName = 'es-rcph'
export type EsRcphProductName = typeof esRcphProductName

// Product versions for es-rcph were created before we agreed on a unified standard.
// This is why we use an empty prefix, for retro-compatibility.
type EsRcphProductVersionFormat = ProductVersionFormat<EsRcphProductName, ''>

export const esRcphProductVersions = [
  /**
   * Initial version
   */
  'es-rcph-1.0.0-2024-11-19',
  /**
   * This new version introduces a change in the commitment logic: users
   * are now required to commit for at least 1 year, even if their
   * payment-recurrence is "monthly".
   */
  'es-rcph-1.0.1-2025-12-11',
] as const satisfies EsRcphProductVersionFormat[]

export type EsRcphProductVersion = (typeof esRcphProductVersions)[number]
